import * as React from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import { getApi, patchApi } from 'views/services/api';
import { formatHotelDate, getHotelMoment } from 'utils/timeZone';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useState, useEffect } from 'react';
import moment from 'moment';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router';
import Iconify from 'ui-component/iconify';
import ShowAllFoodItem from './showAllFoodItem';
import SegoRoomCharges from './SegoRoomCharges';
import CheckInReservation from '../CheckInReservation';
import EditReservation from '../EditReservation';
import ChangeRoom from '../ChangeRoom';
import AddReservation from '../AddReservations';
import RoomInvoiceDialog from './RoomInvoiceDialog';
import CheckOut from '../CheckOutReservation';
import ShowBill from './ShowBills';
import FoodInvoiceDialog from './FoodInvoiceDialog';
import SingleInvoiceDialog from './SingleInvoiceDialog';
import Visitor from 'views/VisitorInformation';
import { constant } from 'views/constant';
import axios from 'axios';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Tooltip from '@mui/material/Tooltip';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import HotelIcon from '@mui/icons-material/Hotel';
import PersonIcon from '@mui/icons-material/Person';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import PaymentIcon from '@mui/icons-material/Payment';
import PaymentsIcon from '@mui/icons-material/Payments';
import BadgeIcon from '@mui/icons-material/Badge';
import HistoryIcon from '@mui/icons-material/History';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import EventRepeatIcon from '@mui/icons-material/EventRepeat';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import ReservationHistoryDialog from './ReservationHistoryDialog';
import PendingPaymentModal from './PendingPaymentModal';
import ReservationPayments from './ReservationPayments';

// Styled Components con diseño moderno - 30% más compacto
const StyledCard = styled(Card)(({ theme }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  transition: 'all 0.3s ease',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: theme.shadows[6]
  }
}));

const SectionHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  marginBottom: theme.spacing(1.5),
  paddingBottom: theme.spacing(1),
  borderBottom: `2px solid ${theme.palette.primary.main}`
}));

const InfoRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(0.8, 1),
  borderRadius: theme.spacing(0.7),
  marginBottom: theme.spacing(0.6),
  backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.02)',
  transition: 'background-color 0.2s',
  '&:hover': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.04)'
  }
}));

const StatusChip = styled(Chip)(({ theme, status }) => {
  const statusColors = {
    pending: { bg: '#FFF4E5', color: '#FF8C00', border: '#FFB84D' },
    active: { bg: '#E8F5E9', color: '#2E7D32', border: '#66BB6A' },
    completed: { bg: '#E3F2FD', color: '#1565C0', border: '#42A5F5' }
  };

  const colors = statusColors[status] || statusColors.pending;

  return {
    backgroundColor: colors.bg,
    color: colors.color,
    borderColor: colors.border,
    fontWeight: 600,
    fontSize: '0.75rem',
    height: '26px',
    border: `1px solid ${colors.border}`
  };
});

const AmountDisplay = styled(Typography)(({ theme, highlight }) => ({
  fontWeight: highlight ? 700 : 600,
  fontSize: highlight ? '1.1rem' : '0.875rem',
  color: highlight ? theme.palette.primary.main : theme.palette.text.primary
}));

export default function ReservationDashboard() {
  const navigate = useNavigate();
  const params = useParams();
  const reservationId = params.id;
  const FinalCheckInTime = moment().format('hh:mm A');
  const hotel = JSON.parse(localStorage.getItem('hotelData'));
  const currency = hotel?.currency || 'USD';

  const [tabOption, setTabOption] = useState('2');
  const [firstTabOption, setFirstTabOption] = useState('1');
  const [openEdit, setOpenEdit] = useState(false);
  const [openAdd, setOpenAdd] = useState(false);
  const [openGenerateInv, setOpenGenerateInv] = useState(false);
  const [openFoodInv, setOpenFoodInv] = useState(false);
  const [openSingleInv, setOpenSingleInv] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [openCheckIn, setOpenCheckIn] = useState(false);
  const [openChangeRoom, setOpenChangeRoom] = useState(false);
  const [openHistory, setOpenHistory] = useState(false);
  const [openPaymentModal, setOpenPaymentModal] = useState(false);

  const [reservationData, setReservationData] = useState([]);
  const [totalFoodAmount, setTotalFoodAmount] = useState(0);
  const [segoChargesTotal, setSegoChargesTotal] = useState(0);
  // Folio calculado por el servidor: cargos, pagos y saldo. Ver
  // services/folioService.js. Mientras no llegue, `pendingAmount` cae al
  // cálculo viejo para que la pantalla nunca quede sin números.
  const [folio, setFolio] = useState(null);
  const [billData, setBillData] = useState([]);
  const [singleBillData, setSingleBillData] = useState([]);

  const [isRoomStatusPending, setIsRoomStatusPending] = useState(false);
  const [isRoomCheckedIn, setIsRoomCheckedIn] = useState(false);
  const [isRoomCheckedOut, setIsRoomCheckedOut] = useState(false);
  const [stayTypes, setStayTypes] = useState([]);

  useEffect(() => {
    const fetchHotelSettings = async () => {
      try {
        if (hotel?.hotelId) {
          const response = await getApi(`api/hotel/view/${hotel.hotelId}`);
          if (response && response.status === 200) {
            setStayTypes(response.data.stayTypes || []);
          }
        }
      } catch (error) {
        console.error('Failed to fetch hotel settings', error);
      }
    };
    fetchHotelSettings();
  }, []);

  const handleCloseAdd = () => setOpenAdd(false);
  const handleOpenEditlead = () => setOpenEdit(true);
  const handleCloseEditReservation = () => setOpenEdit(false);

  const handleOpenGenerateRoomDialog = () => setOpenGenerateInv(true);
  const handleCloseGenerateRoomInvoiceDialog = () => setOpenGenerateInv(false);

  const handleOpenFoodInvoice = () => setOpenFoodInv(true);
  const handleCloseFoodInvoice = () => setOpenFoodInv(false);

  const handleOpenSingleInvoice = () => setOpenSingleInv(true);
  const handleCloseSingleInvoice = () => setOpenSingleInv(false);

  const handleOpenCheckOut = () => {
    // Aviso temprano para no abrir el diálogo en vano. La regla de verdad la
    // aplica el servidor en deleteReservation: esto es cortesía, no control.
    if (pendingAmount > 0) {
      toast.error(`No se puede hacer Check-out: La reserva tiene un saldo pendiente de ${pendingAmount.toFixed(2)}`);
      return;
    }

    if (!reservationData?.checkOutDate) {
      toast.error('No se encontró fecha de salida para esta reserva');
      return;
    }

    const checkOutDate = getHotelMoment(reservationData.checkOutDate).startOf('day');
    const currentDate = getHotelMoment().startOf('day');
    const daysDifference = currentDate.diff(checkOutDate, 'days');
    const scheduledDateFormatted = checkOutDate.format('DD [de] MMM, YYYY');

    if (daysDifference === 0) {
      setOpenDelete(true);
    } else if (daysDifference === 1) {
      toast.warning(`Salida tardía: El huésped debía salir ayer (${scheduledDateFormatted})`);
      setOpenDelete(true);
    } else if (daysDifference > 1) {
      const confirmed = window.confirm(
        `El huésped tiene ${daysDifference} días de retraso (programado: ${scheduledDateFormatted}). Esto podría ser una situación de no-show. ¿Proceder con el checkout?`
      );
      if (confirmed) {
        setOpenDelete(true);
      }
    } else if (daysDifference === -1) {
      toast.info(`Salida anticipada: El huésped sale 1 día antes (programado: ${scheduledDateFormatted})`);
      setOpenDelete(true);
    } else {
      const confirmed = window.confirm(
        `Salida muy anticipada (${Math.abs(daysDifference)} días antes de la fecha programada: ${scheduledDateFormatted}). ¿Proceder?`
      );
      if (confirmed) {
        setOpenDelete(true);
      }
    }
  };

  const handleCloseCheckout = () => setOpenDelete(false);
  const handleOpenCheckIn = () => setOpenCheckIn(true);
  const handleCloseCheckIn = () => setOpenCheckIn(false);
  const handleOpenChangeRoom = () => setOpenChangeRoom(true);
  const handleCloseChangeRoom = () => setOpenChangeRoom(false);

  const calculateTotalFoodAmount = () => {
    if (!reservationData || !reservationData.foodItems) return 0;
    return reservationData.foodItems.reduce(
      (total, foodData) => total + (Number(foodData.quantity) || 0) * (Number(foodData.price) || 0),
      0
    );
  };

  const fetchSegoCharges = async () => {
    try {
      const r = await getApi(`api/room-charges-admin/by-reservation/${reservationId}?includeReversed=false`);
      if (r?.data?.totals) {
        setSegoChargesTotal(r.data.totals.postedTotal || 0);
      }
    } catch (e) {
      console.error('Error al obtener cargos Sego:', e);
    }
  };

  const fetchFolio = async () => {
    try {
      const r = await getApi(`api/reservation/folio/${reservationId}`);
      if (r?.data?.balance) setFolio(r.data);
    } catch (e) {
      // Sin folio la pantalla sigue funcionando con el cálculo viejo.
      console.error('Error al obtener el folio:', e);
    }
  };

  const fetchReservationData = async () => {
    try {
      const response = await getApi(`api/reservation/view/${reservationId}`);
      const data = response.data.reservationData[0];
      setReservationData(data);
      if (data.status === 'pending') setIsRoomStatusPending(true);
      else if (data.status === 'active') setIsRoomCheckedIn(true);
      else setIsRoomCheckedOut(true);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchBillData = async () => {
    try {
      const response = await getApi(`api/invoice/view/${reservationId}`);
      setBillData(response?.data?.InvoiceData);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchSingleBillData = async () => {
    try {
      const response = await getApi(`api/singleinvoice/view/${reservationId}`);
      setSingleBillData(response?.data?.InvoiceData);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchReservationData();
    fetchBillData();
    fetchSingleBillData();
    fetchSegoCharges();
    fetchFolio();
  }, [openAdd, openEdit, openDelete, openCheckIn, openChangeRoom, openGenerateInv, openFoodInv, openSingleInv]);

  useEffect(() => {
    setTotalFoodAmount(calculateTotalFoodAmount());
  }, [reservationData]);

  /**
   * Saldo pendiente de la reserva.
   *
   * Sale del folio del servidor. El cálculo de respaldo (totalAmount + comida +
   * Sego) es el que se usaba antes y NO descuenta lo ya pagado de comida ni de
   * Sego: solo cuadraba porque `totalAmount` se iba a negativo y compensaba.
   * Queda como red por si el endpoint falla, no como fuente.
   */
  const pendingAmount = folio
    ? Number(folio.balance.total)
    : (reservationData?.totalAmount || 0) + Number(totalFoodAmount) + Number(segoChargesTotal);

  const handleAddFoodClick = () => navigate(`/dashboard/reservation/addfood/${reservationId}`);
  const handleTabChange = (event, newValue) => setTabOption(newValue);
  const handleFirstTabChange = (event, newValue) => setFirstTabOption(newValue);

  // Determinar estado para el chip
  const getReservationStatus = () => {
    if (isRoomCheckedOut) return { label: 'Completada', status: 'completed' };
    if (isRoomCheckedIn) return { label: 'Activa', status: 'active' };
    return { label: 'Pendiente', status: 'pending' };
  };

  const reservationStatus = getReservationStatus();

  // Saldo total pendiente, calculado por el servidor (ver pendingAmount).
  const pendingBalance = pendingAmount;
  const hasPendingBalance = pendingBalance > 0;

  // ─── Lógica de Reserva Expirada (No-Show) ───────────────────────────────
  // Determina si el tipo de estancia es nocturno o por horas
  const isNightlyStay = () => {
    if (!reservationData?.stayType) return true;
    if (reservationData.stayType === 'night') return true;
    if (reservationData.stayType === 'partial') return false;
    // Buscar en los stayTypes configurados del hotel
    const stayTypeObj = stayTypes.find((t) => String(t._id) === String(reservationData.stayType));
    if (stayTypeObj) return stayTypeObj.isNightly === true;
    return true; // fallback: tratar como noche si no se encuentra
  };

  // Grace period: 4h para estadías nocturnas, 1.5h para cualquier estancia por horas
  const graceHours = isNightlyStay() ? 4 : 1.5;

  // La reserva está expirada si sigue pending y el check-in ya superó el período de gracia
  const isExpiredReservation =
    isRoomStatusPending &&
    !!reservationData?.checkInDate &&
    moment().isAfter(moment(reservationData.checkInDate).add(graceHours, 'hours'));

  // Handler para terminar una reserva expirada (no-show)
  const handleEndExpiredReservation = async () => {
    const checkInFormatted = reservationData?.checkInDate
      ? formatHotelDate(reservationData.checkInDate)
      : 'N/A';
    const confirmed = window.confirm(
      `El huésped no se presentó.\n` +
      `Habitación #${reservationData?.roomNo} | Check-in programado: ${checkInFormatted}\n\n` +
      `Al confirmar, la reserva quedará completada y la habitación pasará al ciclo de limpieza.\n` +
      `¿Deseas terminar esta reserva?`
    );
    if (!confirmed) return;

    try {
      // 1. Completar la reserva (mismo endpoint que checkout)
      const result = await patchApi(`api/reservation/delete/${reservationId}`, {
        ...reservationData,
        FinalCheckOutTime: moment().format('hh:mm A')
      });

      if (result) {
        // 2. Marcar habitación como sucia para iniciar ciclo de limpieza
        if (reservationData?.roomId) {
          await patchApi(`api/room/housekeeping-status/${reservationData.roomId}`, {
            housekeepingStatus: 'dirty'
          });
        }
        toast.success(
          `Reserva terminada. Habitación #${reservationData?.roomNo} enviada a limpieza.`
        );
        navigate(-1);
      } else {
        toast.error('No se pudo terminar la reserva. Intenta nuevamente.');
      }
    } catch (error) {
      console.error('Error al terminar reserva expirada:', error);
      toast.error('Error al terminar la reserva.');
    }
  };
  // ────────────────────────────────────────────────────────────────────────

  return (
    <>
      <CheckOut open={openDelete} handleClose={handleCloseCheckout} data={reservationData} />
      <CheckInReservation open={openCheckIn} handleClose={handleCloseCheckIn} data={reservationData} />
      <AddReservation open={openAdd} handleClose={handleCloseAdd} />
      <EditReservation open={openEdit} handleClose={handleCloseEditReservation} data={reservationData} />
      <ChangeRoom open={openChangeRoom} handleClose={handleCloseChangeRoom} data={reservationData} />
      <RoomInvoiceDialog open={openGenerateInv} handleClose={handleCloseGenerateRoomInvoiceDialog} data={reservationData} />
      <FoodInvoiceDialog open={openFoodInv} handleClose={handleCloseFoodInvoice} data={reservationData} />
      <SingleInvoiceDialog open={openSingleInv} handleClose={handleCloseSingleInvoice} data={reservationData} />
      <ReservationHistoryDialog open={openHistory} handleClose={() => setOpenHistory(false)} reservationId={reservationId} />
      <PendingPaymentModal
        open={openPaymentModal}
        handleClose={() => setOpenPaymentModal(false)}
        reservationId={reservationId}
        pendingAmount={pendingAmount}
        fetchReservationData={() => {
          fetchReservationData();
          fetchBillData();
          fetchSingleBillData();
          fetchSegoCharges();
        }}
      />

      {/* Header con información de estado */}
      <Box sx={{ mb: 2 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
          <Box>
            <Typography variant="h5" fontWeight="700" gutterBottom sx={{ mb: 0.5 }}>
              Reserva #{reservationData?.roomNo || 'N/A'}
            </Typography>
            <StatusChip label={reservationStatus.label} status={reservationStatus.status} size="small" />
          </Box>
          <Button variant="outlined" startIcon={<ArrowBackIcon />} size="medium" onClick={() => navigate(-1)}>
            Regresar
          </Button>
        </Stack>
      </Box>

      <Box sx={{ width: '100%' }}>
        <TabContext value={firstTabOption}>
          <Box sx={{ borderBottom: 2, borderColor: 'divider', mb: 2 }}>
            <TabList onChange={handleFirstTabChange} textColor="primary" indicatorColor="primary">
              <Tab label="Información de la Reserva" value="1" sx={{ fontWeight: 600, fontSize: '0.875rem', py: 1 }} />
              <Tab label="Visitantes" value="2" sx={{ fontWeight: 600, fontSize: '0.875rem', py: 1 }} />
            </TabList>
          </Box>

          <TabPanel value="1" sx={{ p: 0 }}>
            <Grid container spacing={2}>
              {/* Card de Habitación */}
              <Grid item xs={12} lg={6}>
                <StyledCard>
                  <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                    <SectionHeader>
                      <HotelIcon color="primary" sx={{ fontSize: 22 }} />
                      <Typography variant="subtitle1" fontWeight="700">
                        Información de la Habitación
                      </Typography>
                    </SectionHeader>

                    <InfoRow>
                      <Typography variant="body2" color="text.secondary" fontSize="0.8rem">
                        Número de Habitación
                      </Typography>
                      <Typography variant="body2" fontWeight="600" fontSize="0.875rem">
                        {reservationData?.roomNo || 'N/A'}
                      </Typography>
                    </InfoRow>

                    <InfoRow>
                      <Typography variant="body2" color="text.secondary" fontSize="0.8rem">
                        Tipo de Estadía
                      </Typography>
                      <Typography variant="body2" fontWeight="600" fontSize="0.875rem">
                        {(() => {
                          if (!reservationData?.stayType) return 'N/A';
                          if (reservationData.stayType === 'night') return 'Noche';
                          if (reservationData.stayType === 'partial') return 'Estadía Parcial';
                          if (reservationData.stayTypeLabel) return reservationData.stayTypeLabel;
                          const type = stayTypes.find((t) => String(t._id) === String(reservationData.stayType));
                          return type ? type.label : reservationData.stayType;
                        })()}
                      </Typography>
                    </InfoRow>

                    <Divider sx={{ my: 1.2 }} />

                    <InfoRow>
                      <Stack direction="row" spacing={0.7} alignItems="center">
                        <CalendarTodayIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
                        <Typography variant="body2" color="text.secondary" fontSize="0.8rem">
                          Entrada
                        </Typography>
                      </Stack>
                      <Typography variant="body2" fontWeight="600" fontSize="0.875rem">
                        {reservationData?.checkInDate ? formatHotelDate(reservationData.checkInDate) : 'N/A'}
                      </Typography>
                    </InfoRow>

                    <InfoRow>
                      <Stack direction="row" spacing={0.7} alignItems="center">
                        <CalendarTodayIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
                        <Typography variant="body2" color="text.secondary" fontSize="0.8rem">
                          Salida
                        </Typography>
                      </Stack>
                      <Typography variant="body2" fontWeight="600" fontSize="0.875rem">
                        {reservationData?.checkOutDate ? formatHotelDate(reservationData.checkOutDate) : 'N/A'}
                      </Typography>
                    </InfoRow>

                    <InfoRow>
                      <Typography variant="body2" color="text.secondary" fontSize="0.8rem">
                        Total de Días
                      </Typography>
                      <Chip
                        label={`${reservationData?.totalDays || 0} días`}
                        color="primary"
                        variant="outlined"
                        size="small"
                        sx={{ height: '24px', fontSize: '0.75rem' }}
                      />
                    </InfoRow>

                    <Divider sx={{ my: 1.2 }} />

                    <Box sx={{ backgroundColor: 'primary.lighter', p: 1.3, borderRadius: 1.5, mt: 1.5 }}>
                      <InfoRow sx={{ backgroundColor: 'transparent', mb: 0 }}>
                        <Typography variant="body2" color="text.secondary" fontWeight="600" fontSize="0.8rem">
                          Precio Total de Habitación
                        </Typography>
                        <AmountDisplay highlight>
                          {currency} {reservationData?.totalPayment?.toFixed(2) || '0.00'}
                        </AmountDisplay>
                      </InfoRow>
                    </Box>
                  </CardContent>
                </StyledCard>
              </Grid>

              {/* Card de Información Financiera */}
              <Grid item xs={12} lg={6}>
                <StyledCard>
                  <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                    <SectionHeader>
                      <PaymentIcon color="primary" sx={{ fontSize: 22 }} />
                      <Typography variant="subtitle1" fontWeight="700">
                        Información Financiera
                      </Typography>
                    </SectionHeader>

                    {(reservationData?.payments && reservationData.payments.length > 0) ||
                      (reservationData?.splitPayments && reservationData.splitPayments.length > 0) ? (
                      <Box>
                        <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1.5 }}>
                          <Typography variant="body2" color="text.secondary" fontWeight="600">
                            Historial de Pagos
                          </Typography>
                          <Chip
                            label={`${(reservationData?.payments || reservationData?.splitPayments || []).length} Pagos`}
                            size="small"
                            color="info"
                            variant="outlined"
                            sx={{ height: 20, fontSize: '0.65rem' }}
                          />
                        </Stack>

                        <Box sx={{ maxHeight: 200, overflowY: 'auto', mb: 2, pr: 0.5 }}>
                          {(reservationData?.payments || reservationData?.splitPayments || []).map((payment, index) => (
                            <Box
                              key={index}
                              sx={{
                                p: 1.5,
                                mb: 1,
                                borderRadius: 1.5,
                                border: '1px solid',
                                borderColor: 'divider',
                                bgcolor: 'background.default',
                                position: 'relative',
                                overflow: 'hidden'
                              }}
                            >
                              <Box
                                sx={{
                                  position: 'absolute',
                                  left: 0,
                                  top: 0,
                                  bottom: 0,
                                  width: 4,
                                  bgcolor: 'primary.main'
                                }}
                              />
                              <Grid container spacing={1} alignItems="center">
                                <Grid item xs={6}>
                                  <Typography variant="caption" color="text.secondary" display="block">
                                    {payment.addedAt ? moment(payment.addedAt).format('DD MMM, YYYY') : `Pago #${index + 1}`}
                                  </Typography>
                                  <Stack direction="row" spacing={0.5} alignItems="center">
                                    <Typography variant="body2" fontWeight="700">
                                      {currency} {payment.amount?.toFixed(2)}
                                    </Typography>
                                    {payment.currency && payment.currency !== 'USD' && (
                                      <Chip
                                        label={payment.currency}
                                        size="small"
                                        sx={{
                                          height: 16,
                                          fontSize: '0.6rem',
                                          bgcolor: 'primary.lighter',
                                          color: 'primary.dark'
                                        }}
                                      />
                                    )}
                                  </Stack>
                                </Grid>
                                <Grid item xs={6} sx={{ textAlign: 'right' }}>
                                  <Chip
                                    label={payment.paymentMethod || 'Pago'}
                                    size="small"
                                    variant="outlined"
                                    sx={{
                                      height: 22,
                                      fontSize: '0.7rem',
                                      borderColor: 'divider',
                                      textTransform: 'capitalize'
                                    }}
                                  />
                                  {payment.amountInForeignCurrency && (
                                    <Typography variant="caption" display="block" color="text.secondary" sx={{ mt: 0.5 }}>
                                      ({payment.currency} {parseFloat(payment.amountInForeignCurrency).toFixed(2)})
                                    </Typography>
                                  )}
                                </Grid>
                              </Grid>
                            </Box>
                          ))}
                        </Box>
                        <Divider sx={{ my: 1.5 }} />
                      </Box>
                    ) : (
                      <>
                        <InfoRow>
                          <Typography variant="body2" color="text.secondary" fontSize="0.8rem">
                            Método de Pago
                          </Typography>
                          <Chip
                            label={reservationData?.paymentMethod || 'N/A'}
                            color="secondary"
                            variant="outlined"
                            size="small"
                            sx={{ height: '24px', fontSize: '0.7rem' }}
                          />
                        </InfoRow>

                        <InfoRow>
                          <Typography variant="body2" color="text.secondary" fontSize="0.8rem">
                            Moneda de Pago
                          </Typography>
                          <Typography variant="body2" fontWeight="600" fontSize="0.875rem">
                            {reservationData?.paymentCurrency || 'USD'}
                          </Typography>
                        </InfoRow>

                        <InfoRow>
                          <Typography variant="body2" color="text.secondary" fontSize="0.8rem">
                            Tasa de Cambio
                          </Typography>
                          <Typography variant="body2" fontWeight="600" fontSize="0.875rem">
                            {reservationData?.exchangeRateUsed || '1.00'}
                          </Typography>
                        </InfoRow>

                        {reservationData?.amountInForeignCurrency && (
                          <InfoRow>
                            <Typography variant="body2" color="text.secondary" fontSize="0.8rem">
                              Monto en Moneda Extranjera
                            </Typography>
                            <Typography variant="body2" fontWeight="600" fontSize="0.875rem">
                              {reservationData?.paymentCurrency} {parseFloat(reservationData?.amountInForeignCurrency).toFixed(2)}
                            </Typography>
                          </InfoRow>
                        )}

                        <Divider sx={{ my: 1.2 }} />
                      </>
                    )}

                    {reservationData?.promoCodeDetails && (
                      <InfoRow sx={{ backgroundColor: 'rgba(76, 175, 80, 0.08)' }}>
                        <Typography variant="body2" color="success.main" fontWeight="600" fontSize="0.8rem">
                          Cupón Aplicado ({reservationData.promoCodeDetails.code})
                        </Typography>
                        <AmountDisplay sx={{ color: 'success.main', fontWeight: 700 }}>
                          -{currency} {reservationData?.discountAmount?.toFixed(2) || '0.00'}
                        </AmountDisplay>
                      </InfoRow>
                    )}

                    <InfoRow>
                      <Typography variant="body2" color="text.secondary" fontSize="0.8rem">
                        Adelanto
                      </Typography>
                      <AmountDisplay>
                        {currency} {reservationData?.advanceAmount?.toFixed(2) || '0.00'}
                      </AmountDisplay>
                    </InfoRow>

                    <InfoRow>
                      <Typography variant="body2" color="text.secondary" fontSize="0.8rem">
                        Monto Restante
                      </Typography>
                      <AmountDisplay>
                        {currency} {reservationData?.totalAmount?.toFixed(2) || '0.00'}
                      </AmountDisplay>
                    </InfoRow>

                    <InfoRow>
                      <Stack direction="row" spacing={0.7} alignItems="center">
                        <RestaurantIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
                        <Typography variant="body2" color="text.secondary" fontSize="0.8rem">
                          Gastos de Restaurante
                        </Typography>
                      </Stack>
                      <AmountDisplay>
                        {currency} {Number(totalFoodAmount).toFixed(2)}
                      </AmountDisplay>
                    </InfoRow>

                    <InfoRow>
                      <Stack direction="row" spacing={0.7} alignItems="center">
                        <RestaurantIcon sx={{ fontSize: 16, color: '#c2410c' }} />
                        <Typography variant="body2" color="text.secondary" fontSize="0.8rem">
                          Cargos Sego
                        </Typography>
                      </Stack>
                      <AmountDisplay>
                        {currency} {Number(segoChargesTotal).toFixed(2)}
                      </AmountDisplay>
                    </InfoRow>

                    <Divider sx={{ my: 1.2 }} />

                    <Box sx={{ backgroundColor: 'success.lighter', p: 1.3, borderRadius: 1.5, mt: 1.5 }}>
                      <InfoRow sx={{ backgroundColor: 'transparent', mb: 0 }}>
                        <Typography variant="body2" fontWeight="700" fontSize="0.85rem">
                          Total General (Pendiente)
                        </Typography>
                        <AmountDisplay highlight sx={{ fontSize: '1.25rem' }}>
                          {currency} {pendingAmount.toFixed(2)}
                        </AmountDisplay>
                      </InfoRow>
                    </Box>
                  </CardContent>
                </StyledCard>
              </Grid>

              {/* Card de Cliente */}
              <Grid item xs={12}>
                <StyledCard>
                  <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                    <SectionHeader>
                      <PersonIcon color="primary" sx={{ fontSize: 22 }} />
                      <Typography variant="subtitle1" fontWeight="700">
                        Información del Cliente
                      </Typography>
                    </SectionHeader>

                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6} md={4}>
                        <InfoRow>
                          <Typography variant="body2" color="text.secondary" fontSize="0.8rem">
                            Nombre Completo
                          </Typography>
                          <Typography variant="body2" fontWeight="600" fontSize="0.875rem">
                            {reservationData?.fullName || 'N/A'}
                          </Typography>
                        </InfoRow>
                      </Grid>

                      <Grid item xs={12} sm={6} md={4}>
                        <InfoRow>
                          <Typography variant="body2" color="text.secondary" fontSize="0.8rem">
                            Correo Electrónico
                          </Typography>
                          <Typography variant="body2" fontWeight="600" sx={{ wordBreak: 'break-word', fontSize: '0.875rem' }}>
                            {reservationData?.customerDetails?.email || 'N/A'}
                          </Typography>
                        </InfoRow>
                      </Grid>

                      <Grid item xs={12} sm={6} md={4}>
                        <InfoRow>
                          <Typography variant="body2" color="text.secondary" fontSize="0.8rem">
                            Teléfono
                          </Typography>
                          <Typography variant="body2" fontWeight="600" fontSize="0.875rem">
                            {reservationData?.customerDetails?.phoneNumber || 'N/A'}
                          </Typography>
                        </InfoRow>
                      </Grid>

                      <Grid item xs={12} sm={6} md={4}>
                        <InfoRow>
                          <Typography variant="body2" color="text.secondary" fontSize="0.8rem">
                            Dirección
                          </Typography>
                          <Typography variant="body2" fontWeight="600" fontSize="0.875rem">
                            {reservationData?.customerDetails?.address || 'N/A'}
                          </Typography>
                        </InfoRow>
                      </Grid>

                      <Grid item xs={12} sm={6} md={4}>
                        <InfoRow>
                          <Stack direction="row" spacing={0.7} alignItems="center">
                            <BadgeIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
                            <Typography variant="body2" color="text.secondary" fontSize="0.8rem">
                              {reservationData?.customerDetails?.idCardType || 'Identificación'}
                            </Typography>
                          </Stack>
                          <Typography variant="body2" fontWeight="600" fontSize="0.875rem">
                            {reservationData?.customerDetails?.idcardNumber || 'N/A'}
                          </Typography>
                        </InfoRow>
                      </Grid>

                      <Grid item xs={12} sm={6} md={4}>
                        <InfoRow>
                          <Typography variant="body2" color="text.secondary" fontSize="0.8rem">
                            Documento
                          </Typography>
                          <a href={reservationData?.idFile} target="_blank" rel="noreferrer">
                            <Button startIcon={<VisibilityIcon />} variant="contained" size="small" sx={{ fontSize: '0.75rem', py: 0.5 }}>
                              Ver ID
                            </Button>
                          </a>
                        </InfoRow>
                      </Grid>
                    </Grid>
                  </CardContent>
                </StyledCard>
              </Grid>

              {/* Card de Acompañantes */}
              {reservationData?.customers && reservationData.customers.length > 1 && (
                <Grid item xs={12}>
                  <StyledCard>
                    <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                      <SectionHeader>
                        <Stack direction="row" spacing={1} alignItems="center">
                          <PersonIcon color="primary" sx={{ fontSize: 22 }} />
                          <Typography variant="subtitle1" fontWeight="700">
                            Información de Acompañantes
                          </Typography>
                          <Chip
                            label={`${reservationData.customers.length - 1} ${reservationData.customers.length - 1 === 1 ? 'Persona' : 'Personas'
                              }`}
                            size="small"
                            color="primary"
                            variant="outlined"
                            sx={{ height: 20, fontSize: '0.65rem' }}
                          />
                        </Stack>
                      </SectionHeader>

                      <Grid container spacing={2}>
                        {reservationData.customers
                          .filter((customer) => customer && customer._id && customer._id !== reservationData.customerDetails._id)
                          .map((companion, index) => (
                            <Grid item xs={12} key={index}>
                              <Box
                                sx={{
                                  p: 2,
                                  borderRadius: 2,
                                  border: '1px solid',
                                  borderColor: 'divider',
                                  bgcolor: 'background.default'
                                }}
                              >
                                <Grid container spacing={2}>
                                  <Grid item xs={12} sm={6} md={3}>
                                    <InfoRow>
                                      <Typography variant="body2" color="text.secondary" fontSize="0.8rem">
                                        Nombre Completo
                                      </Typography>
                                      <Typography variant="body2" fontWeight="600" fontSize="0.875rem">
                                        {companion.firstName} {companion.lastName}
                                      </Typography>
                                    </InfoRow>
                                  </Grid>

                                  <Grid item xs={12} sm={6} md={3}>
                                    <InfoRow>
                                      <Typography variant="body2" color="text.secondary" fontSize="0.8rem">
                                        Teléfono
                                      </Typography>
                                      <Typography variant="body2" fontWeight="600" fontSize="0.875rem">
                                        {companion.phoneNumber || 'N/A'}
                                      </Typography>
                                    </InfoRow>
                                  </Grid>

                                  <Grid item xs={12} sm={6} md={3}>
                                    <InfoRow>
                                      <Stack direction="row" spacing={0.7} alignItems="center">
                                        <BadgeIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
                                        <Typography variant="body2" color="text.secondary" fontSize="0.8rem">
                                          {companion.idCardType || 'Identificación'}
                                        </Typography>
                                      </Stack>
                                      <Typography variant="body2" fontWeight="600" fontSize="0.875rem">
                                        {companion.idcardNumber || 'N/A'}
                                      </Typography>
                                    </InfoRow>
                                  </Grid>

                                  <Grid item xs={12} sm={6} md={3}>
                                    <InfoRow>
                                      <Typography variant="body2" color="text.secondary" fontSize="0.8rem">
                                        Documento
                                      </Typography>
                                      {companion.idFile ? (
                                        <Button
                                          href={companion.idFile}
                                          target="_blank"
                                          rel="noreferrer"
                                          startIcon={<VisibilityIcon />}
                                          variant="outlined"
                                          size="small"
                                          fullWidth
                                          sx={{ fontSize: '0.75rem', py: 0.5 }}
                                        >
                                          Ver Documento
                                        </Button>
                                      ) : (
                                        <Typography variant="caption" color="text.secondary">
                                          No adjunto
                                        </Typography>
                                      )}
                                    </InfoRow>
                                  </Grid>
                                </Grid>
                              </Box>
                            </Grid>
                          ))}
                      </Grid>
                    </CardContent>
                  </StyledCard>
                </Grid>
              )}
            </Grid>
          </TabPanel>

          <TabPanel value="2" sx={{ p: 0 }}>
            <Visitor isRoomCheckedOut={isRoomCheckedOut} reservationId={reservationId} />
          </TabPanel>
        </TabContext>
      </Box>

      {/* Botones de Acción */}
      <Box
        sx={{
          mt: 2.5,
          p: 2,
          backgroundColor: 'background.paper',
          borderRadius: 1.5,
          boxShadow: 1
        }}
      >
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} flexWrap="wrap" justifyContent="flex-end">
          {isRoomStatusPending || (isRoomCheckedIn && !isRoomCheckedOut) ? (
            <Button
              variant="contained"
              startIcon={<RestaurantIcon />}
              color="primary"
              onClick={handleAddFoodClick}
              size="medium"
              sx={{ fontSize: '0.875rem' }}
            >
              Agregar Comida
            </Button>
          ) : null}

          {/* Siempre visible: si esta deshabilitado es porque no hay saldo, y el
              tooltip lo explica. Antes desaparecia y parecia una funcion rota. */}
          {!isRoomCheckedOut && (
            <Tooltip title={hasPendingBalance ? 'Registrar un abono o pagar el saldo' : 'Esta reserva no tiene saldo pendiente'}>
              <span>
                <Button
                  variant="contained"
                  color="secondary"
                  startIcon={<PaymentIcon />}
                  onClick={() => setOpenPaymentModal(true)}
                  size="medium"
                  disabled={!hasPendingBalance}
                  sx={{
                    fontSize: '0.875rem',
                    fontWeight: 700,
                    boxShadow: hasPendingBalance ? '0 2px 8px rgba(156,39,176,0.4)' : 'none',
                    '&:hover': {
                      boxShadow: '0 4px 14px rgba(156,39,176,0.5)'
                    }
                  }}
                >
                  Abonar / Pagar Saldo
                </Button>
              </span>
            </Tooltip>
          )}

          {/* Botón No-Show: aparece cuando el huésped no llegó y el período de gracia expiró */}
          {isExpiredReservation && (
            <Button
              variant="contained"
              color="warning"
              startIcon={<EventBusyIcon />}
              onClick={handleEndExpiredReservation}
              size="medium"
              sx={{
                fontSize: '0.875rem',
                fontWeight: 700,
                boxShadow: '0 2px 8px rgba(237,108,2,0.4)',
                '&:hover': {
                  boxShadow: '0 4px 14px rgba(237,108,2,0.5)'
                }
              }}
            >
              Terminar Reserva
            </Button>
          )}

          {isRoomCheckedOut && reservationData?.foodItems?.length > 0 && !singleBillData && (
            <Button variant="outlined" color="primary" onClick={handleOpenSingleInvoice} size="medium" sx={{ fontSize: '0.875rem' }}>
              Generar Factura Única
            </Button>
          )}

          {!billData?.some((item) => item.type === 'room') && isRoomCheckedOut && (
            <Button variant="outlined" color="primary" onClick={handleOpenGenerateRoomDialog} size="medium" sx={{ fontSize: '0.875rem' }}>
              Factura de Habitación
            </Button>
          )}

          {!billData?.some((item) => item.type === 'food') && isRoomCheckedOut && reservationData?.foodItems?.length > 0 && (
            <Button variant="outlined" color="primary" onClick={handleOpenFoodInvoice} size="medium" sx={{ fontSize: '0.875rem' }}>
              Factura de Comida
            </Button>
          )}

          {!isRoomCheckedIn && !isRoomCheckedOut && (
            <Button variant="contained" color="success" onClick={handleOpenCheckIn} size="medium" sx={{ fontSize: '0.875rem' }}>
              Check-In Final
            </Button>
          )}

          {(isRoomStatusPending || (isRoomCheckedIn && !isRoomCheckedOut)) && (
            <Button variant="contained" color="error" onClick={handleOpenCheckOut} size="medium" sx={{ fontSize: '0.875rem' }}>
              Check-Out Final
            </Button>
          )}

          {!isRoomCheckedOut && (
            <Button
              startIcon={<EventRepeatIcon />}
              variant="outlined"
              color="primary"
              onClick={handleOpenEditlead}
              size="medium"
              sx={{ fontSize: '0.875rem' }}
            >
              Modificar Estadía
            </Button>
          )}

          {!isRoomCheckedOut && (
            <Button
              startIcon={<SwapHorizIcon />}
              variant="outlined"
              onClick={handleOpenChangeRoom}
              size="medium"
              sx={{
                fontSize: '0.875rem',
                color: 'orange.dark',
                borderColor: 'orange.dark',
                '&:hover': { borderColor: 'orange.dark', backgroundColor: 'orange.light' }
              }}
            >
              Cambiar Habitación
            </Button>
          )}

          <Button
            startIcon={<HistoryIcon />}
            variant="outlined"
            color="secondary"
            onClick={() => setOpenHistory(true)}
            size="medium"
            sx={{ fontSize: '0.875rem' }}
          >
            Historial
          </Button>
        </Stack>
      </Box>

      {/* Tabs de Comidas y Facturas */}
      <Box sx={{ width: '100%', mt: 2.5 }}>
        <TabContext value={tabOption}>
          <Box sx={{ borderBottom: 2, borderColor: 'divider' }}>
            <TabList onChange={handleTabChange} textColor="primary" indicatorColor="primary">
              <Tab
                icon={<RestaurantIcon sx={{ fontSize: 20 }} />}
                iconPosition="start"
                label="Comidas"
                value="1"
                sx={{ fontWeight: 600, fontSize: '0.875rem', py: 1 }}
              />
              <Tab
                icon={<PaymentIcon sx={{ fontSize: 20 }} />}
                iconPosition="start"
                label="Facturas"
                value="2"
                sx={{ fontWeight: 600, fontSize: '0.875rem', py: 1 }}
              />
              <Tab
                icon={<RestaurantIcon sx={{ fontSize: 20 }} />}
                iconPosition="start"
                label="Cargos Sego"
                value="3"
                sx={{ fontWeight: 600, fontSize: '0.875rem', py: 1 }}
              />
              <Tab
                icon={<PaymentsIcon sx={{ fontSize: 20 }} />}
                iconPosition="start"
                label="Pagos"
                value="4"
                sx={{ fontWeight: 600, fontSize: '0.875rem', py: 1 }}
              />
            </TabList>
          </Box>
          <TabPanel value="1" sx={{ p: 2 }}>
            <ShowAllFoodItem />
          </TabPanel>
          <TabPanel value="2" sx={{ p: 2 }}>
            <ShowBill />
          </TabPanel>
          <TabPanel value="3" sx={{ p: 2 }}>
            <SegoRoomCharges reservationId={reservationId} />
          </TabPanel>
          <TabPanel value="4" sx={{ p: 2 }}>
            <ReservationPayments reservation={reservationData} currency={currency} pendingBalance={pendingBalance} />
          </TabPanel>
        </TabContext>
      </Box>
    </>
  );
}
